import { render, staticRenderFns } from "./image-upload-widget.vue?vue&type=template&id=a59142fc&scoped=true&"
import script from "./image-upload-widget.vue?vue&type=script&lang=js&"
export * from "./image-upload-widget.vue?vue&type=script&lang=js&"
import style0 from "./image-upload-widget.vue?vue&type=style&index=0&id=a59142fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59142fc",
  null
  
)

export default component.exports